import styled from "styled-components"
import SingleSelectSimple from "../../../Ui/Form/SingleSelectSimple"
import { theme } from "../../../../theme"
import Input from "../../../Ui/Form/Input"

type StyledProps = {
  $selected: boolean
}

export const Container = styled.div`
  margin-top: 1rem;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1rem;

  ${theme.mQ.MEDIA_MIN_X_LARGE} {
    flex-direction: row;
  }
`
export const ActionButtonWrapper = styled.div`
display: flex;

  button {
    margin-right: 1rem;
  }
`

export const Button = styled.button<StyledProps>`
  appearance: none;
  width: 100%;
  border: 0.1rem solid ${({ theme, $selected }) => $selected ? theme.colors.turquoiseDark : theme.colors.borderLight};
  padding: 1.5rem 1rem;
  border-radius: 0.6rem;
  background: ${p => p.$selected ? p.theme.colors.turquoiseDark : p.theme.colors.white};
  color: ${p => p.$selected ? p.theme.colors.white : p.theme.colors.black};
  margin-bottom: 1rem;

  ${theme.mQ.MEDIA_MIN_X_LARGE} {
    width: 32%;
  }

  b {
    font-size: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      height: 1.2rem;
      margin-right: 0.5rem;
      fill: ${p => p.$selected ? p.theme.colors.white : p.theme.colors.black};
    }
  }

  span {
    font-size: 1rem;
    font-weight: 400;
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  &:hover {
    cursor: pointer;
  }
`

export const Info = styled.div`
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0.5rem 0;

  a {
    margin-left: 0.2rem;
    text-decoration: underline;
  }

  svg {
    height: 1.2rem;
    margin-right: 0.5rem;
  }
`

export const InputWrapper = styled.div`
  width: 100%;
`

export const StyledSelect = styled(SingleSelectSimple)`
  margin-bottom: 2rem;
`

export const StyledInput = styled(Input)`
  padding-bottom: 0;
`
